import React from "react";
import Link from "./Link";
import { Box, Button, AppBar, Toolbar, Typography, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import AuthButton from "../../layouts/headerUiEl/AuthButton";
import { CustomIcon } from './SitemarkIcon';


/*
    기존의 메뉴 구조 형태 PC환경 메뉴 구조
*/
const MyAppBarDefault = (props) => {
    const { auth, t } = props;

    const GradientTypography = styled(Typography)({
        background: "transparent",
        color: "transparent",
        overflow: "hidden",
        WebkitBackgroundClip: "text",
        backgroundClip: "text",
        backgroundImage: "linear-gradient(45deg, #003399 30%, #CC0066 90%)",
        "&:hover": {
        backgroundImage: "linear-gradient(45deg, #CC0066 30%, #003399 90%)",
        },
    });

    /*
        2025.04.03
        position="fixed" 헤더 메뉴가 떠 있는 것과 같음으로 바디 페이지의 Top Padding을 Header 높이 만큼 설정하여야 한다.
                        수정하면 App.js 파일을 수정하여 처리함
                        REACT_APP_HEADER_SIZE 설정 값을 참조한다.
        position="static" 이면 헤더 메뉴도 페이지에 포함되어 스크롤될때 메뉴도 올라가버리는 문제가 있음
    */
    return (
        <AppBar
            position="fixed"
            color="default"
            elevation={0}
            height={process.env.REACT_PAGE_HEADER_SIZE}
            sx={{ 
            boxShadow: 0,
            bgcolor: 'background.paper',
            backgroundImage: 'none',
            borderBottom: (theme) => `1px solid ${theme.palette.divider}` ,
            borderColor: 'divider',
            top: 'var(--template-frame-height, 0px)',
            height: `${process.env.REACT_PAGE_HEADER_SIZE}`,
            }}
        >
            <Toolbar variant="regular"
                sx={{
                    height: `${process.env.REACT_PAGE_HEADER_SIZE}`,
                    flexWrap: "wrap",
                    boxShadow: 3,
                    bgcolor: (theme) =>
                    theme.palette.mode === "dark" ? "#101010" : "#fff",
                }}
            >
            <Stack
                direction="row"
                sx={{
                alignItems: 'center',
                flexGrow: 1,
                width: '100%',
                gap: 1,
                display: { xs: 'none', md: 'flex' }
                }}
            >
                <Stack
                    direction="row"
                    spacing={1}
                    sx={{ justifyContent: 'center', mr: 'auto' }}
                >
                <Typography
                    component="h1"
                    variant="h4"
                    color="inherit"
                    noWrap
                    flexGrow="1"
                    lineHeight={0}
                    sx={{ flexGrow: 1 }}
                >
                    <Link href="/" underline="none">
                    <img
                        src={`${process.env.PUBLIC_URL}/images/logo.svg`}
                        alt="logo"
                        style={{
                        height: "100%",
                        left: "0",
                        position: "absolute",
                        top: "0",
                        paddingLeft: "24px",
                        }}
                    />
                    </Link>
                </Typography>
                </Stack>
            </Stack>

            <Box
                sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                width: "100%",
                gap: 1,
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                    }}
                >
                <nav style={{ display: "flex", justifyContent: "center" }}>

                    {(auth?.userId?.length > 0 && auth?.userType === process.env.REACT_APP_BOARD_MANAGER_TYPE) ?
                    <>
                    <Link
                        href="/manage4member"
                        variant="button"
                        color="text.primary"
                        sx={{ my: 1, mx: 1.5, color: "#29314A" }}
                        underline="none"
                    >
                        <Button>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>{t('nav.manage4member')}</Typography>
                        </Button>
                    </Link>

                    <Link
                        href="/manage4board"
                        variant="button"
                        color="text.primary"
                        sx={{ my: 1, mx: 1.5, color: "#29314A" }}
                        underline="none"
                    >
                        <Button>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>{t('nav.manage4board')}</Typography>
                        </Button>
                    </Link>

                    <Link
                        href="/manage4article"
                        variant="button"
                        color="text.primary"
                        sx={{ my: 1, mx: 1.5, color: "#29314A" }}
                        underline="none"
                    >
                        <Button>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>{t('nav.manage4article')}</Typography>
                        </Button>
                    </Link>

                    <Link
                        href="/manage4reply"
                        variant="button"
                        color="text.primary"
                        sx={{ my: 1, mx: 1.5, color: "#29314A" }}
                        underline="none"
                    >
                        <Button>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>{t('nav.manage4reply')}</Typography>
                        </Button>
                    </Link>
                    </>
                    : null
                    }

                    <Link
                        href="/intro"
                        variant="button"
                        color="text.primary"
                        sx={{ my: 1, mx: 1.5, color: "#29314A" }}
                        underline="none"
                    >
                    <Button>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>{t('nav.about')}</Typography>
                    </Button>
                    </Link>

                    <Link
                        href="/search"
                        variant="button"
                        color="text.primary"
                        sx={{ my: 1, mx: 1.5, color: "#29314A" }}
                        underline="none"
                    >
                    <Button>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>{t('nav.search')}</Typography>
                    </Button>
                    </Link>

                    <Link
                        href="/mypage"
                        variant="button"
                        color="text.primary"
                        sx={{ my: 1, mx: 1.5, color: "#29314A" }}
                        underline="none"
                    >
                    <Button>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>{t('nav.mypage')}</Typography>
                    </Button>
                    </Link>

                    <Link
                        href="/statistics"
                        variant="button"
                        color="text.primary"
                        sx={{ my: 1, mx: 1.5, color: "#29314A" }}
                        underline="none"
                    >
                    <Button>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>{t('nav.statics')}</Typography>
                    </Button>
                    </Link>

                    <Link
                        href="/faq"
                        variant="button"
                        color="text.primary"
                        sx={{ my: 1, mx: 1.5, color: "#29314A" }}
                        underline="none"
                    >
                    <Button>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>{t('nav.board1')}</Typography>
                    </Button>
                    </Link>

                    <Link
                        href="/qna"
                        variant="button"
                        color="text.primary"
                        sx={{ my: 1, mx: 1.5, color: "#29314A" }}
                        underline="none"
                    >
                    <Button>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>{t('nav.board2')}</Typography>
                    </Button>
                    </Link>

                    <Link
                        href="/board"
                        variant="button"
                        color="text.primary"
                        sx={{ my: 1, mx: 1.5, color: "#29314A" }}
                        underline="none"
                    >
                    <Button>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>{t('nav.board3')}</Typography>
                    </Button>
                    </Link>

                </nav>

                <Link href="http://auction.sensco.top/#/" underline="none">
                    <Button>
                    <CustomIcon />
                    <Typography>
                        Coffee
                        <GradientTypography component="span">
                        Auction
                        </GradientTypography>
                    </Typography>
                    </Button>
                </Link>

                </Box>

                <AuthButton />

            </Box>

            </Toolbar>
        </AppBar>
    );
};

export default MyAppBarDefault;
